export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return !!token;
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.location.href = '/login';
};

export const setAuth = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};

// Staff emails explicitly granted access to admin-only tabs. Kept as a
// hardcoded allowlist because the business rule is "only this named person"
// rather than a role. Mirror this list in backend/dependencies.py.
export const PRODUCTS_STAFF_ALLOWLIST = ['samrathsalunke2@gmail.com'];

export const canEditProducts = (user) => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  if (user.role === 'staff' && PRODUCTS_STAFF_ALLOWLIST.includes((user.email || '').toLowerCase())) {
    return true;
  }
  return false;
};